import { Injectable } from '@angular/core';

import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError, catchError } from 'rxjs';

import { ErrorNotificationService } from '../services/error-notification.service';

import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorSvc: ErrorNotificationService,
    private router: Router,
    private auth: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';

        switch (error.status) {
          case 401:
            // Force logout and redirect to login page
            this.auth.logout({ logoutParams: { returnTo: document.location.origin } });
            this.showError(
              'Your session has expired. Please log in again.',
              false
            );
            break;

          case 403:
            this.showError(
              'Access Denied. The request you are making seems suspisious or you do not have access to the requested resource!'
            );

            break;

          case 404:
            this.showError(
              'The resource you are attempting to access could not be found. Please verify your links and try again!'
            );

            break;

          case 500:
          case 503:
            this.showError(
              'A server error occurred. Please try again later or contact support.'
            );
            break;

          default:
            this.showError(
              'An unexpected error occurred. Please try again.'
            );
        }

        //Display a user friendly message

        return throwError(() => error);
      })
    );
  }

  showError(message: string, navigateToErrorPage: boolean = true) {
    this.errorSvc.notify(message);

    if (navigateToErrorPage) {
      this.router.navigate(['/error']);
    }
  }
}
